<div class="card-product -title">
  @if (icon) {
  <icon [icon]="icon" [class]="iconsize + ' ' + iconcolor"></icon>
  }
  <h3>{{ title }}</h3>
</div>
<ng-content></ng-content>
